import { createStore } from 'effector';
import { alwaysNew } from '~/shared/lib/alwaysNew';
import { setPayinNewOrdersCount } from './events';

export const $payinNewOrdersCount = createStore(0).on(setPayinNewOrdersCount, alwaysNew);
